import { Access } from '../../enums';
import { Permission } from '../permission';

const LISTS_KEY = 'lists';
export const LISTS = {
  READ: new Permission({
    key: `${LISTS_KEY}:${Access.READ}`,
    description: 'Auswertungen und Listen - Leserecht',
  }),

  WRITE: new Permission({
    key: `${LISTS_KEY}:${Access.WRITE}`,
    description: 'Auswertungen und Listen - Schreibrecht',
  }),

  MEDICATION: new Permission({
    key: `${LISTS_KEY}:medication-list:${Access.READ}`,
    description: 'Medikamentenstellliste - Leserecht',
  }),

  VISIT_SHEET_QUESTIONS: new Permission({
    key: `${LISTS_KEY}:visit-sheet-list:${Access.READ}`,
    description: 'Visitenfragen-Liste - Leserecht',
  }),

  NURSING_OVERVIEW: new Permission({
    key: `${LISTS_KEY}:nursing-overview-list:${Access.READ}`,
    description: 'Pflegeübersicht-Liste - Leserecht',
  }),

  HOSPITAL: new Permission({
    key: `${LISTS_KEY}:visit-sheet-list:${Access.READ}`,
    description: 'Krankenhaus-Export-Liste - Leserecht',
  }),

  BULK_HOSPITAL: new Permission({
    key: `${LISTS_KEY}:visit-sheet-list:${Access.READ}`,
    description: 'Krankhaus-Sammelexport-Liste - Leserecht',
  }),

  RISK_GROUPS: new Permission({
    key: `${LISTS_KEY}:risk-groups-list:${Access.READ}`,
    description: 'Risikogruppen-Liste - Leserecht',
  }),

  RISK_LIST: new Permission({
    key: `${LISTS_KEY}:risk-list:${Access.READ}`,
    description: 'Risikoliste - Leserecht',
  }),

  BASE_DATA_GENERAL: new Permission({
    key: `${LISTS_KEY}:base-data-general:${Access.READ}`,
    description: 'Stammdaten-Liste - allgemeines - Leserecht',
  }),

  BASE_DATA_REFERENCE_CARE: new Permission({
    key: `${LISTS_KEY}:base-data-reference-care:${Access.READ}`,
    description: 'Stammdaten-Liste - Bezugspflege - Leserecht',
  }),

  BASE_DATA_KV: new Permission({
    key: `${LISTS_KEY}:base-data-kv:${Access.READ}`,
    description: 'Stammdaten-Liste - KV - Leserecht',
  }),

  BASE_DATA_CONSULTING: new Permission({
    key: `${LISTS_KEY}:base-data-consulting:${Access.READ}`,
    description: 'Stammdaten-Liste - Beratung - Leserecht',
  }),

  EXTERNAL_INFORMATION: new Permission({
    key: `${LISTS_KEY}:external-information:${Access.READ}`,
    description: 'Stammdaten-Liste - Beratung - Leserecht',
  }),

  EMPLOYEE_BASE_DATA_GENERAL: new Permission({
    key: `${LISTS_KEY}:employee-base-data-general:${Access.READ}`,
    description: 'Stammdaten-Liste - Mitarbeiter - Leserecht',
  }),
};
